import { default as carModelAndVersion } from './carModelAndVersion';
import { default as carRegistrationNumber } from './carRegistrationNumber';
import { default as vin } from './vin';
import { default as obfuscation } from './obfuscation';
import { default as nightParkingPlace } from './nightParkingPlace';
import { default as previousInsurer } from './previousInsurer';
import { default as drivingWheelLocation } from './drivingWheelLocation';
import { default as additionalDrivers } from './additionalDrivers';

export const car = {
  ...carModelAndVersion,
  ...carRegistrationNumber,
  ...vin,
  ...obfuscation,
  ...nightParkingPlace,
  ...previousInsurer,
  ...drivingWheelLocation,
  ...additionalDrivers,
};
